var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loader)?_c('div',{staticClass:"spinner-overlay"},[_c('div',{staticClass:"spinner-container"},[_c('half-circle-spinner',{attrs:{"animation-duration":1000,"size":60,"color":"#26527A"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }